module.exports = __webpack_public_path__ + "img/ec.b526c480.svg";